module.exports = __webpack_public_path__ + "img/ex2.916d2eff.png";